import React from 'react';

import type { IPriceNoticeHint } from './types';

class PriceNoticeHint extends React.PureComponent<IPriceNoticeHint> {
  static hint: any;

  static set hintInstance(instance) {
    this.hint = instance;
  }

  static get hintInstance() {
    return this.hint;
  }

  render() {
    const { children, onClose } = this.props;
    return (
      <div className="react-hint__content tooltip-warning__content">
        {children}
        <button className="react-hint__close" type="button" onClick={onClose} />
      </div>
    );
  }
}

export default PriceNoticeHint;
